import { createRouter, createWebHistory } from 'vue-router'
import cookieHandler from '../../utils/cookies/cookieHandler'
import { useAuthUser } from '../../../utils/stores/modules/authUser'
import SignupRoot from '../Root.vue'
import SinglePageSignup from '../views/SinglePageSignup.vue'

const B2BSignup = () => import('../../SignupA/views/B2b.vue')
const Loader = () => import('../views/Loader.vue')

const ConfirmationNewUser = () => import('../../SignupA/views/confirmation/confirmationNewUser.vue')
const ConfirmationExistingUser = () => import('../../SignupA/views/confirmation/confirmationExistingUser.vue')
const ConfirmationUnclaimedUser = () => import('../../SignupA/views/confirmation/confirmationUnclaimedUser.vue')

const CheckoutRoot = () => import('../../SignupA/views/checkout/Root.vue')
const CheckoutNewUser = () => import('../../SignupA/views/checkout/checkoutNewUser.vue')
const CheckoutExistingUser = () => import('../../SignupA/views/checkout/checkoutExistingUser.vue')

function checkParents(to, from) {
  if (to.meta.entryPoint) return true
  if (
    (to.meta.parents && to.meta.parents.includes(from.name)) ||
    (from.meta.parents && from.meta.parents.includes(to.name)) ||
    from.path === "/coffee-plans/signup-2-single"
  ) {
    return true
  } else {
    var params_keep = new URLSearchParams(window.location.search)
    var params_send = {}
    params_keep.forEach(function (value, key) {
      params_send[key] = value
    })
    return { name: 'Loader', query: params_send }
  }
}

const routes = [
  {
    path: '/coffee-plans/signup-2-single',
    component: SignupRoot,
    redirect: () => {
      // the function receives the target route as the argument
      // we return a redirect path/location here.
      var params_keep = new URLSearchParams(window.location.search)
      var params_send = {}
      params_keep.forEach(function (value, key) {
        params_send[key] = value
      })
      return { name: 'Loader', query: params_send }
    },
    children: [
      { path: '/:pathMatch(.*)*', name: 'NotFound', component: SinglePageSignup },
      { path: '', name: 'Loader', component: Loader },
      {
        path: '',
        name: 'single-page-signup',
        component: SinglePageSignup,
        meta: { parents: ['/', '', undefined], entryPoint: true },
        beforeEnter: [checkParents],
      },
      {
        path: '/b2b',
        component: B2BSignup,
        name: 'B2B',
        meta: { parents: ['New User', 'Existing User', 'single-page-signup', '/'] },
      },
      {
        name: 'Confirmation new',
        path: 'confirmation-new',
        meta: { parents: ['New User'] },
        component: ConfirmationNewUser,
      },
      {
        name: 'Confirmation unclaimed',
        path: 'confirmation-unclaimed',
        meta: { parents: ['New User', 'Existing User'] },
        component: ConfirmationUnclaimedUser,
      },
      {
        name: 'Confirmation user',
        path: 'confirmation-user',
        meta: { parents: ['Existing User', 'New User'] },
        component: ConfirmationExistingUser,
      },
      {
        path: 'checkout',
        name: 'checkout',
        component: CheckoutRoot,
        meta: { parents: ['single-page-signup'] },
        beforeEnter: [checkParents],
        redirect: { name: 'New User' },
        children: [
          {
            path: '',
            name: 'Existing User',
            component: CheckoutExistingUser,
            beforeEnter: () => {
              const userStore = useAuthUser()
              if (!cookieHandler.hasToken()) return { name: 'New User' }
              else {
                userStore.getUserInfo()
                userStore.getAddresses()
                userStore.getCards()
              }
            },
          },
          {
            path: '',
            name: 'New User',
            component: CheckoutNewUser,
            props: true,
            beforeEnter: () => {
              if (cookieHandler.hasToken()) return { name: 'Existing User' }
            },
          },
        ],
      },
    ],
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach(function (to, from, next) {
  setTimeout(() => {
    window.scrollTo(0, 0)
  }, 100)
  next()
})

export default router
